<template>
    <div>
        <div>
            <template v-if="data.type === 'new'">
                <i18n path="Notification - New card comment" tag="span">
                    <span place="user" class="font-weight-bold">{{ data.employee_name }}</span>
                    <router-link place="child" :to="mapRoute" class="font-weight-bold">{{ data.child_name }}</router-link>
                </i18n>
            </template>
            <template v-else-if="data.type === 'resolved'">
                <i18n path="Notification - Card comment resolved" tag="span">
                    <span place="user" class="font-weight-bold">{{ data.employee_name }}</span>
                    <router-link place="child" :to="mapRoute" class="font-weight-bold">{{ data.child_name }}</router-link>
                    <span place="comment" class="text-muted">{{ truncate(stripHtmlTags(data.comment_preview || ''), 64) }}</span>
                </i18n>
            </template>
            <span v-if="data.type === 'resolved'" class="float-right">{{ $t('Status') }}: <span class="text-success font-weight-bold">{{ $t('Resolved') }}</span></span>
        </div>
        <div v-if="data.type === 'new'" class="text-truncate overflow-hidden">
            <span class="text-muted">{{ truncate(stripHtmlTags(data.comment_preview || ''), 128) }}</span>
        </div>
        <div class="text-muted">
            {{ formatDateTime(notification.created_at) }}
        </div>
    </div>
</template>

<script>
import { formatDateTime, stripHtmlTags, truncate } from '@/filters';

export default {
    name: 'CommentNotification',
    props: {
        notification: Object
    },
    computed: {
        data() {
            return this.notification.data;
        },
        mapRoute() {
            const { child_id, employee_id, field_id, id, map_id } = this.data;
            return { name: 'child.map', params: { child_id, employee_id, field_id, map_id, comment_id: id } };
        }
    },
    methods: {
        formatDateTime, // TODO: Vue3 remove
        stripHtmlTags, // TODO: Vue3 remove
        truncate // TODO: Vue3 remove
    }
};
</script>
